var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.patientVotDetail != null)?_c('div',_vm._l((_vm.patientVotDetail),function(data,key){return _c('div',{key:data},[_c('span',{staticClass:"vot-data data-title"},[_vm._v(" "+_vm._s(_vm.$t(key))+": ")]),_c('span',{staticClass:"vot-data data-value"},[_vm._v(" "+_vm._s(data)+" ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }